import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalLoaderService } from '@app-core/providers/global-loader.service';
import { SidebarService } from '@app-core/providers/sidebar.service';
import { UserPrincipalService } from '@app-core/providers/user-principal.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent implements OnInit {

  constructor(private userService: UserPrincipalService,
              private router: Router,
              private sidebar: SidebarService,
              private globalLoader: GlobalLoaderService,
              private readonly userPrincipal: UserPrincipalService) {
  }

  ngOnInit() {
  }

  public logout(): void {
    this.userService.logout()
      .then(() => this.router.navigate(['/login']));
  }

  toggleSideNav() {
    this.sidebar.sideNavOpenStatus$.next(!this.sidebar.sideNavOpenStatus$.value);
  }

  public get email(): string {
    return this.userPrincipal.email;
  }

  public get showLoader(): Observable<number> {
    return this.globalLoader.loadingState$;
  }

}
